'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable'),
	_ = require('underscore');
module.exports = function IconEditorController(iconPersisterModel, picker, dimensionCalculator, authenticator) {
	let currentIcon = false,
		forNode = false;

	const self = observable(this),
		onImagePicked = function (newIcon)  {
			dimensionCalculator(newIcon.url).then(function (dimensions) {
				const oldPosition = currentIcon && currentIcon.position;
				currentIcon = _.extend({}, newIcon, {
					width: dimensions.width,
					height: dimensions.height,
					position: oldPosition || 'left'
				});
				if (!forNode) {
					self.save();
				} else {
					self.dispatchEvent('stage', 'confirm');
				}
			}, function () {
				self.dispatchEvent('stage', 'image-error');
			});
		},
		onPickerError = function (reason) {
			if (reason === 'cancel') {
				self.dispatchEvent('cancel');
			} else {
				self.dispatchEvent('stage', 'image-error');
			}
		},
		onPickerNotify = function (stage, arg) {
			self.dispatchEvent('stage', stage, arg);
		},
		openPicker = function (userProfile) {
			self.dispatchEvent('pickerActive');
			picker.pickImage(userProfile, {notify: onPickerNotify})
				.then(onImagePicked, onPickerError);
		};
	iconPersisterModel.addEventListener('nodeIconEditRequested', function () {
		self.editIconForSelectedNode();
	});
	iconPersisterModel.addEventListener('progressIconEditRequested', function () {
		self.editIconProgressIcon();
	});
	self.save = function () {
		if (forNode) {
			if (currentIcon) {
				iconPersisterModel.setIcon('icon-editor', currentIcon.url, currentIcon.width, currentIcon.height, currentIcon.position, undefined, currentIcon.metaData);
			} else {
				iconPersisterModel.setIcon(false);
			}
		} else {
			if (currentIcon) {
				iconPersisterModel.dropImage(currentIcon.url, currentIcon.width, currentIcon.height, undefined, undefined, currentIcon.metaData);
			}
		}
		self.dispatchEvent('complete');
	};
	self.addPictureNode = function () {
		forNode = false;
		self.pickImage();
	};
	self.editIconProgressIcon = function () {
		forNode = true;
		currentIcon = _.clone(iconPersisterModel.getIcon());

		if (currentIcon) {
			self.dispatchEvent('reload');
			self.dispatchEvent('stage', 'view');
		} else {
			self.pickImage();
		}
	};
	self.editIconForSelectedNode = function () {
		forNode = true;
		currentIcon = _.clone(iconPersisterModel.getIcon());
		if (currentIcon) {
			self.dispatchEvent('stage', 'view');
		} else {
			self.pickImage();
		}
	};
	self.getCurrentIcon = function () {
		return currentIcon;
	};
	self.removeIcon = function () {
		currentIcon = false;
		self.save();
	};
	self.setDimensions = function (width, height) {
		if (currentIcon) {
			currentIcon.width = parseFloat(width);
			currentIcon.height = parseFloat(height);
		}
	};
	self.setPosition = function (position) {
		if (currentIcon) {
			currentIcon.position = position;
		}
	};
	self.pickImage = function () {
		if (!authenticator) {
			openPicker();
		} else {
			authenticator.backgroundAuthenticate().then(
				openPicker,
				function () {
					self.dispatchEvent('stage', 'auth');
				}
			);
		}
	};
	self.authorise = function () {
		authenticator.modalAuthenticate().then(
			openPicker,
			function () {
				self.dispatchEvent('stage', 'auth-fail');
			}
		);
	};
};
